import { Checkbox, Grid } from '@mui/material'

const GridCheckbox = ({
  label,
  field,
  value,
  onChange = () => {},
  md = 6,
  justifyContent = 'center',
  disabled,
}) => (
  <Grid size={{ xs: 12, md }}>
    <Grid
      container
      alignItems='center'
      justifyContent={justifyContent}
      sx={{ width: '100%' }}
    >
      <Grid size='auto'>
        <Checkbox
          color='default'
          checked={!!value}
          onChange={event => onChange(field, event.target.checked)}
          disabled={disabled}
        />
      </Grid>
      {label && <Grid size='grow'>{label}</Grid>}
    </Grid>
  </Grid>
)

export default GridCheckbox
